import { DEFAULT_NA_STRING } from "@/app/config-global";
import moment from "moment";

const getAppDate = (date: any) =>
  date ? moment(date).format("ll") : DEFAULT_NA_STRING;

export default getAppDate;
